import { Flex } from '@lokalise/louis';
import { styled } from '@lokalise/styled';

import { color, spacing, typography } from '@app/theme';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 50%;
    margin: 0 auto;
`;

export const HeadingContainer = styled(Flex)`
    margin-block-end: ${spacing(7)};
`;

export const Heading = styled.h1`
    ${typography('heading.1')};
`;

export const Text = styled.p`
    color: ${color('text.light.default')};
    ${typography('body.base.default')};
    text-align: center;
`;
